import React from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Modal,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Divider,
  FormControl,
  Grid,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "../ItemRequest.css";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { FilterObj_Set } from "../SliceItemCreationRequest";
import { useDispatch, useSelector } from "react-redux";

const FilterModal = ({ open, handleClose, status, itemRequestSummary, vMediaQuery }) => {
  const dispatch = useDispatch();
  const LocWithoutRights = useSelector(
    (state) => state.SliceDB.value.Location.LocWithRights
  );
  const filterObj = useSelector(
    (state) => state.SliceItemCreationRequest.value.filterObj
  );

  const handleLocationChange = (event) => {
    dispatch(FilterObj_Set({ ...filterObj, loc: event.target.value }));
  };

  const handleStatusChange = (event) => {
    dispatch(FilterObj_Set({ ...filterObj, status: event.target.value }));
  };

  const handleLoad = () => {
    itemRequestSummary();
    // handleClose();
  };
  return (
    <div>
      <Modal open={open} onClose={handleClose}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width:vMediaQuery? "95%": 400,
            backgroundColor:' #ffffff',
            borderRadius: 3,
            boxShadow: 6,
          }}
        >
            <Box className="modal-head">
              <Typography variant="h6" marginLeft={1}>
                Filter
              </Typography>
              <IconButton onClick={handleClose}>
                <CloseIcon sx={{ color: "#ffffff" }} />
              </IconButton>
            </Box>
            <Divider
              sx={{
                "&.MuiDivider-root": {
                  borderColor: "#efeaea !important",
                },
              }}
            />

            <Grid
              container
              spacing={3}
              padding={vMediaQuery ? 2:4}
              className="ItemRequest-filter"
            >
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="From Date"
                    inputFormat="DD/MM/YYYY"
                    name="dateFrom"
                    value={filterObj?.dateFrom}
                    onChange={(newValue) =>
                      dispatch(
                        FilterObj_Set({
                          ...filterObj,
                          dateFrom: newValue.$d,
                        })
                      )
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    label="To Date"
                    inputFormat="DD/MM/YYYY"
                    name="dateTo"
                    value={filterObj?.dateTo}
                    onChange={(newValue) =>
                      dispatch(
                        FilterObj_Set({
                          ...filterObj,
                          dateTo: newValue.$d,
                        })
                      )
                    }
                    renderInput={(params) => (
                      <TextField {...params} fullWidth />
                    )}
                  />
                </LocalizationProvider>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    Location
                  </InputLabel>
                  <Select
                    fullWidth
                    label="Location"
                    name="loc"
                    value={
                      filterObj?.loc === ""
                        ? LocWithoutRights[0]?.Uid
                        : filterObj?.loc
                    }
                    onChange={handleLocationChange}
                  >
                    {LocWithoutRights?.map((typ) => (
                      <MenuItem key={typ.Uid} value={typ.Uid}>
                        {typ.Name1}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Status</InputLabel>
                  <Select
                    name="status"
                    label="Status"
                    value={filterObj?.status}
                    onChange={handleStatusChange}
                  >
                    {status.map((sts) => (
                      <MenuItem key={sts} value={sts}>
                        {sts}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12} textAlign={"center"}>
                <Button
                  variant="contained"
                  sx={{
                    nsform: "none",
                    fontWeight: "bold",
                    borderRadius: 1,
                    width: "40%",
                  }}
                  onClick={handleLoad}
                >
                  Load
                </Button>
              </Grid>
            </Grid>
        </Box>
      </Modal>
    </div>
  );
};

export default FilterModal;
